(function() {
    'use strict';

    angular
        .module('app')
        .controller('settingModalController', settingModalController);

    function settingModalController($uibModalInstance, loginService, $rootScope, modalService,
        viewModel, $q, headerService) {
        var vm = this;
        vm.cancel = cancel;
        vm.submit = submit;
        vm.openEditPwd = openEditPwd;
        vm.openPhoneNumber = openPhoneNumber;
        vm.setFontSize = setFontSize;
        vm.enableperTel = enableperTel;

        vm.view = {
            isEmployee: false,
            isperTel: true
        };

        init();

        function init() {
            vm.settings = viewModel;
            loginService.getSsoInfo().then(function(data) {
                vm.data = {
                    cName: data.data.cName,
                    perTel: data.data.tel
                };
                vm.view.isEmployee = data.data.isEmployee;
                vm.view.perTelcheck = data.data.tel;
                //判斷=1，顯示手機驗證碼按鈕  
                vm.view.moblieIsVerify = data.data.moblieIsVerify;

                enableperTel(data.data.tel);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function submit() {
            loginService.editUserProfile(vm.data);
            $uibModalInstance.dismiss('cancel');
        }

        function openEditPwd() {
            modalService.editPwd().result.then(function() {
                $uibModalInstance.dismiss('cancel');
            });
        }

        function openPhoneNumber() {
            modalService.phoneNumber();
        }

        function setFontSize(item) {
            headerService.setFontSize(item.sizeCode).then(function() {
                 _.each(vm.settings.fontSizes, function(x) {
                    x.isSelected = false;
                });
                $rootScope.fontSize = item.sizeCode;
                item.isSelected = true;
            });
        }

        function enableperTel(tel) {
            if (tel === null){
                vm.view.isperTel = false;
            }
        }
    }
})();
